if (!customElements.get('waitlist-modal')) {
  class WaitlistModal extends HTMLElement {

    constructor() {
      super();

      this.elForm = this.querySelector('form');
      this.elMessage = this.querySelector('[data-message]');
      this.elPopup = this.closest('popup-modal');

      this.elForm.addEventListener('submit', this.submitForm.bind(this));
      this.elForm.addEventListener('change', this.resetForm.bind(this));
    }

    resetForm() {
      this.elMessage.innerHTML = '';
    }

    submitForm(ev) {
      ev.preventDefault();
      this.postData()
        .then(result => {
          if (!result.ok) {
            this.elMessage.innerHTML = 'Oops! Please try again later';
          } else {
            this.elMessage.innerHTML = 'Thanks for signing up!';
            setTimeout(() => this.elPopup.setAttribute('open', false), 3000);
          }
        })
        .catch(err => {
          console.log(err);
          this.elMessage.innerHTML = 'Oops! Please try again later';
        })
    }

    async postData() {
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": this.elForm.querySelector('input').value,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${Number(this.getAttribute('variant-id'))}`
              }
            }
          }
        }
      }
      console.log(payload)

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-06-15"
        },
        body: JSON.stringify(payload)
      }

      const response = await fetch(this.elForm.getAttribute('action'), requestOptions);
      return response;
    }
  }

  customElements.define('waitlist-modal', WaitlistModal);
}